import {
	getLoginToken,
	getPasswordToken,
	getSignupToken,
	submitLogin,
	submitLogout,
	submitPassword,
	submitCode,
	submitPasswordRecover,
	submitPasswordRecoverConfirm,
	submitSignup,
	submitSignupConfirm,
	verifyEmail
} from '../../../helpers/api'

export default {
	isAuthenticationValid: ({ state }) => {
		return Promise.resolve(Boolean(state.accessToken))
	},
	getLoginToken: ({ commit }) => {
		commit('SET_LOADING', true)
		return getLoginToken().then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', data.token)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	getPasswordToken: ({ commit }) => {
		commit('SET_LOADING', true)
		return getPasswordToken().then((data) => {
			commit('SET_LOADING', false)
			commit('SET_PASSWORD_TOKEN', data.token)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	getSignupToken: ({ commit }) => {
		commit('SET_LOADING', true)
		return getSignupToken().then((data) => {
			commit('SET_LOADING', false)
			commit('SET_SIGNUP_TOKEN', data.token)
			commit('SET_SIGNUP_CONFIRM_CODE', '')
			commit('SET_SIGNUP_CONFIRM_CODE_LENGTH', 6)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	submitCode: ({ commit }, { code }) => {
		commit('SET_LOADING', true)
		return submitCode(code).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_SIGNUP_TOKEN', data.token)
			commit('SET_COMPANY_CODE', code)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	verifyEmail: ({ commit, state }, { email, password }) => {
		commit('SET_LOADING', true)
		return verifyEmail(state.signupToken, email, password).then((data) => {
			commit('SET_LOADING', false)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitSignup: ({ commit, state }, { nickname, first_name, last_name, privacy, email, password }) => {
		commit('SET_LOADING', true)
		return submitSignup(state.signupToken, {
			nickname,
			first_name,
			last_name,
			privacy,
			email,
			password
		}).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_SIGNUP_TOKEN', data.token)
			commit('SET_SIGNUP_EMAIL', email)
			if (data.code_length || data.code) {
				commit('SET_SIGNUP_CONFIRM_CODE', data.code)
				commit('SET_SIGNUP_CONFIRM_CODE_LENGTH', data.code_length)
			}
			commit('SET_ACCESS_TOKEN', null)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitPasswordRecover: ({ commit, state }, { email }) => {
		commit('SET_LOADING', true)
		return submitPasswordRecover(state.passwordToken, email).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_SIGNUP_TOKEN', null)
			commit('SET_PASSWORD_TOKEN', data.token)
			commit('SET_SIGNUP_EMAIL', email)
			if (data.code_length || data.code) {
				commit('SET_SIGNUP_CONFIRM_CODE', data.code)
				commit('SET_SIGNUP_CONFIRM_CODE_LENGTH', data.code_length)
			}
			commit('SET_ACCESS_TOKEN', null)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitPasswordRecConfirm: ({ commit, state }, { code }) => {
		commit('SET_LOADING', true)
		return submitPasswordRecoverConfirm(state.passwordToken, code).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_SIGNUP_TOKEN', null)
			commit('SET_PASSWORD_TOKEN', null)
			commit('SET_SIGNUP_EMAIL', '')
			commit('SET_ACCESS_TOKEN', data.access_token)
			commit('SET_TOKEN_TYPE', data.token_type || 'user')
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitSignupConfirm: ({ commit, state }, { code }) => {
		commit('SET_LOADING', true)
		return submitSignupConfirm(state.signupToken, code).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_SIGNUP_TOKEN', null)
			commit('SET_PASSWORD_TOKEN', null)
			commit('SET_SIGNUP_EMAIL', '')
			commit('SET_ACCESS_TOKEN', data.access_token)
			commit('SET_TOKEN_TYPE', data.token_type || 'user')
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitLogin: ({ commit, state }, { email, password }) => {
		commit('SET_LOADING', true)
		return submitLogin(state.loginToken, email, password).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_PASSWORD_TOKEN', null)
			commit('SET_SIGNUP_TOKEN', null)
			commit('SET_ACCESS_TOKEN', data.access_token)
			commit('SET_TOKEN_TYPE', data.token_type || 'user')
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	logout: ({ commit, state }) => {
		commit('SET_LOADING', true)
		return submitLogout(state.accessToken).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_LOGIN_TOKEN', null)
			commit('SET_ACCESS_TOKEN', null)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			if (err.response && err.response.status === 403) {
				commit('SET_LOGIN_TOKEN', null)
				commit('SET_ACCESS_TOKEN', null)
			} else {
				console.error(err.message)
			}
			return Promise.resolve(null)
		})
	},
	submitPassword: ({ commit, state }, data) => {
		commit('SET_LOADING', true)
		return submitPassword(data, state.accessToken).then((data) => {
			commit('SET_LOADING', false)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			if (err.response && err.response.status === 403) {
				commit('SET_LOGIN_TOKEN', null)
				commit('SET_ACCESS_TOKEN', null)
			} else {
				console.error(err.message)
			}
			return Promise.resolve(null)
		})
	},
	clearToken: ({ commit }) => {
		commit('SET_LOADING', false)
		commit('SET_LOGIN_TOKEN', null)
		commit('SET_ACCESS_TOKEN', null)
	}
}
